import React from "react";
import { Grid, useMediaQuery } from "@chakra-ui/react";
import "./Checklist.scss";

export const CheckList = ({
  checkList,
  selectedList,
  parentCallback,
  itemPerRow,
}) => {
  
  const [largeScreen] = useMediaQuery("(max-width: 1100px)");

  const checkboxList = checkList.map((item) => {
    const checked = selectedList.find(
      (sl) => sl.id === item.id
    );
    if (!!checked) {
      return { ...item, checked: true, disabled: !!checked.disabled };
    } else {
      return { ...item, checked: false, disabled: false };
    }
  });

  const updateList = (e) => {
    let updatedListItem = [...selectedList];
    let updatedCheckboxList = [...checkboxList];
    if (e.target.checked) {
      updatedListItem.push(
        checkList.find((item) => item.id === e.target.value)
      );
      const index = updatedCheckboxList.findIndex(
        (list) => list.id === e.target.value
      );
      updatedCheckboxList[index] = {
        ...updatedCheckboxList[index],
        checked: true,
      };
      parentCallback(updatedListItem);
      return true
    } 
    updatedListItem = updatedListItem.filter(
      (item) => item.id !== e.target.value
    );
    const index = updatedCheckboxList.findIndex(
      (list) => list.id === e.target.value
    );
    updatedCheckboxList[index] = {
      ...updatedCheckboxList[index],
      checked: false,
    };
    parentCallback(updatedListItem);
  };

  return (
    <Grid templateColumns={`${largeScreen ? "repeat(4, 1fr)" : `repeat(${itemPerRow}, 1fr)`}`} gap={3}>
      {checkboxList.map(({ id, name, checked, disabled }) => (
        <label className="checkbox-label" key={id}>
          <input
            type="checkbox"
            key={id}
            value={id}
            checked={checked}
            disabled={disabled}
            onChange={updateList}
          />
          {name}
        </label>
      ))}
    </Grid>
  );
};
